import Api from 'utils/api'
import { buildUrl } from 'utils/helpers'
import { showErrorMessage, showInfoMessage } from 'store/ui/actions'
import * as actions from './actions'

export const getAdminCompanies =
  ({ q }) =>
  async (dispatch) => {
    dispatch(actions.getCompaniesRequest())
    try {
      const result = await Api.request(buildUrl(`/admin/companies`, { q }))

      dispatch(actions.getCompaniesSuccess(result))
      return Promise.resolve(result)
    } catch (err) {
      const { error } = await err.json()
      dispatch(actions.getCompaniesError(error))
      return Promise.reject(err)
    }
  }

export const updateCompanyEmergencyClient =
  ({ emergency_client, uuid }) =>
  async (dispatch) => {
    try {
      const result = await Api.request(`/admin/companies/${uuid}`, {
        method: 'PATCH',
        body: JSON.stringify({
          emergency_client,
        }),
      })

      dispatch(showInfoMessage(result?.message))
      dispatch(getAdminCompanies({}))
      return Promise.resolve()
    } catch (err) {
      const { error } = await err.json()
      dispatch(showErrorMessage(error))
      return Promise.reject(err)
    }
  }
